import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import IMAGES from "../../constant/IMAGES";
import useResponsive from "../../hooks/useResponsive";

const icons = [
  IMAGES.icon_1,
  IMAGES.icon_2,
  IMAGES.icon_3,
  IMAGES.icon_4,
  IMAGES.icon_bds,
  IMAGES.icon_daotao,
  IMAGES.icon_giapha,
  IMAGES.icon_lakinh,
  IMAGES.icon_nhangden,
  IMAGES.icon_phongthuy,
  IMAGES.icon_quantri,
  IMAGES.icon_vatpham,
];

const positions = [
  { x: -130, y: -100 },
  { x: 120, y: -130 },
  { x: 120, y: -50 },
  { x: 170, y: 10 },
  { x: 140, y: 80 },
  { x: 70, y: 150 },
  { x: -40, y: 150 },
  { x: -120, y: 100 },
  { x: -160, y: 30 },
  { x: -130, y: -50 },
  { x: -70, y: -140 },
  { x: 0, y: -140 },
];

export default function HeroBubble() {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });
  const { isSmallDevice, isMobileOrTablet } = useResponsive();

  return (
    <div ref={ref} className="relative flex items-center justify-center w-full">
      <div className="relative w-full flex items-center justify-center">
        <img
          src={IMAGES.bongbong1}
          alt="logo"
          className="w-[90%] md:w-full h-full"
        />
        <span className="bg-[#FFFFFF29] bg-[radial-gradient(50.19%_49.92%_at_50.28%_47.09%,#CACACA_0%,#BDBDBD_11%,#9C9C9C_30%,#666666_56%,#1D1D1D_88%,#000000_100%)] mix-blend-color-dodge w-full h-[100px] rounded-full absolute bottom-[-12%] blur-[45px] left-1/2 -translate-x-1/2"></span>

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={
            inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }
          }
          transition={{ duration: 1 }}
          className="absolute text-yellow-400 text-3xl font-bold"
        >
          {/* <img src={IMAGES.logodoc} alt="logo" /> */}
        </motion.div>
        {icons.map((icon, i) => (
          <motion.div
            key={i}
            initial={{ x: 0, y: -150, opacity: 0 }}
            animate={
              inView
                ? {
                    x: isSmallDevice
                      ? positions[i].x * 0.7
                      : isMobileOrTablet
                      ? positions[i].x * 1.2
                      : positions[i].x * 1.3,
                    y: isSmallDevice
                      ? positions[i].y * 0.7
                      : isMobileOrTablet
                      ? positions[i].y * 1.2
                      : positions[i].y * 1.3,
                    opacity: 1,
                  }
                : { x: 0, y: -150, opacity: 0 }
            }
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className="absolute text-yellow-300 text-2xl"
          >
            <img
              src={icon}
              alt="icon"
              className="opacity-40 w-[30px] sm:w-[50px]"
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
